export function getAll() {
  let items = [
    "#E47274",
    "#FEB558",
    "#AFD487",
    "#65B7F3",
    "#B96BC5",
    "#EF6291",
    "#FFD35D",
    "#7988C8",
    "#FE8969",
    "#50B6AC",
  ];
  // let items = [
  //   "#FF0000",
  //   "#FFD500",
  //   "#00ED24",
  //   "#002B8F",
  //   "#FF892E",
  //   "#009569",
  //   "#B18CFF",
  //   "#00FFE1",
  //   "#FFAACB",
  //   "#41005F",
  // ];
  return items;
}
